/**
 * カート追加時のポップアップ。
 *
 * テーマのカートイベント名は Shopify 提供モジュール側で定義されており
 * バージョンで変わりうるため、/cart/add への通信そのものを監視する。
 * こうすると商品ページ・一覧・クイック追加のどこから入れても同じ挙動になる。
 */
(() => {
  const HIDE_AFTER = 3200;
  const root = document.querySelector('[data-gift-toast]');
  if (!root || window.__giftToastReady) return;
  window.__giftToastReady = true;

  const message = root.dataset.giftToastMessage || 'カートに入りました';
  const linkLabel = root.dataset.giftToastLink || '';
  let hideTimer = null;

  const show = () => {
    root.querySelector('[data-gift-toast-text]').textContent = message;
    root.hidden = false;
    // hidden 解除直後だと transition が走らないので次フレームで付ける
    requestAnimationFrame(() => root.classList.add('is-visible'));

    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, HIDE_AFTER);
  };

  const hide = () => {
    root.classList.remove('is-visible');
    clearTimeout(hideTimer);
    const done = () => {
      root.hidden = true;
      root.removeEventListener('transitionend', done);
    };
    // アニメーションを切っている環境では transitionend が来ない
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      done();
    } else {
      root.addEventListener('transitionend', done);
    }
  };

  root.querySelector('[data-gift-toast-close]')?.addEventListener('click', hide);

  const isCartAdd = (input) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    return url.includes('/cart/add');
  };

  // 一覧からのクイック追加のときだけ、カートドロワーは開かせない。
  // ヘッダーのカートアイコンから開く動きはそのまま残す。
  let fromQuickAdd = false;
  document.addEventListener(
    'click',
    (event) => {
      if (event.target instanceof Element && event.target.closest('.quick-add__button')) {
        fromQuickAdd = true;
        setTimeout(() => {
          fromQuickAdd = false;
        }, 2000);
      }
    },
    true
  );

  /** カートのドロワーだけを選ぶ。チャットなど他のドロワーは触らない。 */
  const findOpenCartDrawer = () =>
    [...document.querySelectorAll('theme-drawer')].find(
      (el) => el.isOpen && el.querySelector('cart-drawer-component')
    );

  const closeDrawerIfQuickAdd = () => {
    if (!fromQuickAdd) return;
    // ドロワーが開くのは追加処理の完了後なので、開くまで数フレーム待つ
    let tries = 0;
    const tick = () => {
      const drawer = findOpenCartDrawer();
      if (drawer && typeof drawer.close === 'function') {
        drawer.close();
        return;
      }
      if (++tries < 40) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    try {
      if (isCartAdd(args[0]) && response.ok) {
        show();
        closeDrawerIfQuickAdd();
      }
    } catch (_) {
      // 監視の失敗でカート追加そのものを壊さない
    }
    return response;
  };

  if (linkLabel) {
    root.querySelector('[data-gift-toast-link]')?.classList.remove('is-hidden');
  }
})();
